export default __webpack_public_path__ + "static/media/ImgTitleModal.7cd57a95.jpg";